const API_URL = process.env.REACT_APP_BACKEND_URL;

export async function authFetch(path, options = {}) {
  const token = localStorage.getItem('session_token');
  const headers = { ...options.headers };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  return fetch(`${API_URL}${path}`, {
    ...options,
    headers
  });
}

export function setSessionToken(token) {
  if (token) {
    localStorage.setItem('session_token', token);
  }
}

export function clearSessionToken() {
  localStorage.removeItem('session_token');
}
